/* Isolated Shopify product UI. Cart writes belong to curvila-cactox-cart.js. */
(() => {
  'use strict';
  if (window.CurvilaCactoxProductUI) return;
  const instances = new Map();
  function init(root) {
    if (instances.has(root) || !root.querySelector('[data-cc-product-json]')) return;
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    let data;
    try { data = JSON.parse($('[data-cc-product-json]').textContent); } catch { return; }
    const abort = new AbortController();
    const listen = (target, event, handler, options = {}) => target?.addEventListener(event, handler, { ...options, signal: abort.signal });
    const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobile = () => window.matchMedia('(max-width: 749px)').matches;
    const behavior = () => reduced() ? 'instant' : 'smooth';
    const announce = text => { const target = $('[data-cc-announcer]'); if (target) target.textContent = text; };
    const setText = (selector, text) => $$(selector).forEach(element => { element.textContent = text; });
    const labels = data.labels || {};
    const masksPerBox = Number(data.masksPerBox || root.dataset.masksPerBox) || 4;
    const boxLabel = count => count === 1 ? (labels.box || 'box') : (labels.boxes || 'boxes');
    const countSummary = count => `${count} ${boxLabel(count)} · ${count * masksPerBox} ${labels.masks || 'masks'}`;
    const form = $('[data-cc-form]');
    const variantInput = $('[data-cc-variant-input]');
    const quantityInput = $('[data-cc-quantity-input]');
    const radios = $$('[data-cc-bundle]');
    const selectors = $$('[data-cc-option]');
    let variant = data.variants.find(item => String(item.id) === String(variantInput?.value || data.selectedVariantId)) || data.variants[0] || null;
    let galleryIndex = 0;
    let zoomIndex = 0;
    root.ccProduct = data;
    selectors.forEach(select => { if (variant?.options[Number(select.dataset.optionIndex)] !== undefined) select.value = variant.options[Number(select.dataset.optionIndex)]; });
    const cartBusy = () => root.dataset.ccBusy === 'true';
    function format(variantItem, multiple) { return variantItem?.formattedPrices?.[String(multiple)] || '—'; }
    function availableFor(item, count) {
      if (!item?.available) return false;
      const rule = item.quantity_rule || {};
      const minimum = Number(rule.min) || 1;
      const increment = Number(rule.increment) || 1;
      const maximum = Number(rule.max) || Infinity;
      if (count < minimum || count > maximum || (count - minimum) % increment !== 0) return false;
      if (item.inventory_management && item.inventory_policy !== 'continue' && Number.isFinite(item.inventory_quantity) && count > item.inventory_quantity) return false;
      return true;
    }
    function refreshPurchase({ announceChange = false, clearError = false } = {}) {
      radios.forEach(radio => { radio.disabled = !availableFor(variant, Number(radio.dataset.boxes)); });
      let selected = radios.find(radio => radio.checked);
      if (!selected || selected.disabled) {
        const available = radios.find(radio => !radio.disabled);
        if (available) { available.checked = true; selected = available; }
      }
      const boxes = Number(selected?.dataset.boxes) || 1;
      const paidBoxes = Number(selected?.dataset.paidBoxes) || boxes;
      const canAdd = availableFor(variant, boxes) && !data.requiresSellingPlan;
      if (variantInput) { variantInput.value = variant ? String(variant.id) : ''; variantInput.disabled = !variant; }
      if (quantityInput) quantityInput.value = String(boxes);
      root.ccVariant = variant;
      root.ccSelectedBundle = { id: selected?.value || 'single', boxes, paidBoxes, freeBoxes: boxes - paidBoxes, price: (variant?.price || 0) * paidBoxes };
      $$('[data-cc-unit-price]').forEach(element => { element.textContent = format(variant, 1); });
      $$('[data-cc-total-price]').forEach(element => { element.textContent = format(variant, paidBoxes); });
      radios.forEach(radio => {
        const row = radio.closest('[data-cc-bundle-row]');
        if (!row) return;
        row.classList.toggle('is-selected', radio.checked);
        row.classList.toggle('cc-bundle-unavailable', radio.disabled);
        const rowPrice = row.querySelector('[data-cc-bundle-price]');
        if (rowPrice) rowPrice.textContent = format(variant, Number(radio.dataset.paidBoxes));
        const comparison = row.querySelector('[data-cc-bundle-value]');
        if (comparison) comparison.textContent = format(variant, Number(radio.dataset.boxes));
      });
      const freeShipping = root.dataset.offersEnabled === 'true' && boxes > 1;
      setText('[data-cc-selection-summary]', `${countSummary(boxes)}${freeShipping ? ` · ${labels.freeShipping || 'free shipping'}` : ''}`);
      setText('[data-cc-sticky-summary]', countSummary(boxes));
      $$('[data-cc-shipping-note]').forEach(element => { element.textContent = freeShipping ? element.dataset.ccFreeText : element.dataset.ccStandardText; });
      $$('[data-cc-add]').forEach(button => {
        button.disabled = !canAdd || cartBusy();
        button.dataset.ccAvailable = String(canAdd);
      });
      const actionLabel = data.requiresSellingPlan ? (labels.planRequired || 'Purchase plan required') : !variant ? (labels.unavailable || 'Unavailable') : !variant.available ? (labels.soldOut || 'Sold out') : !canAdd ? (labels.unavailableQuantity || 'Unavailable quantity') : null;
      $$('[data-cc-add-label]').forEach(element => { element.textContent = actionLabel || element.dataset.ccLabel || labels.add || 'Add to bag'; });
      const error = $('[data-cc-form-errors]');
      if (error && !cartBusy()) {
        const message = data.requiresSellingPlan ? 'This product requires a purchase plan. This template does not support subscription-only products.' : !variant ? 'This combination is unavailable. Choose another product option.' : !canAdd && variant.available ? 'The selected offer does not meet this variant’s quantity or availability rules.' : '';
        if (message) {
          error.textContent = message;
          error.hidden = false;
          error.dataset.ccUiError = 'true';
        } else if (announceChange || clearError || error.dataset.ccUiError === 'true') {
          error.textContent = '';
          error.hidden = true;
          delete error.dataset.ccUiError;
        }
      }
      if (announceChange) {
        const variantLabel = variant ? (variant.title && variant.title !== 'Default Title' ? variant.title : data.productTitle) : 'Unavailable option';
        announce(`${variantLabel}. ${boxes} ${boxLabel(boxes)}. ${format(variant, paidBoxes)}.`);
      }
      root.dispatchEvent(new CustomEvent('cc:bundle-change', { bubbles: true, detail: { ...root.ccSelectedBundle, variantId: variant?.id || null, available: canAdd } }));
    }
    function selectVariant() {
      if (cartBusy()) return;
      const options = (variant || data.variants[0])?.options?.slice() || [];
      selectors.forEach(select => { options[Number(select.dataset.optionIndex)] = select.value; });
      variant = data.variants.find(item => item.options.length === options.length && item.options.every((value, index) => String(value) === String(options[index]))) || null;
      refreshPurchase({ announceChange: true });
      if (variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState(window.history.state, '', url);
        showVariantMedia(variant.featured_media_id);
      }
      root.dispatchEvent(new CustomEvent('cc:variant-change', { bubbles: true, detail: { variantId: variant?.id || null, variant } }));
    }
    selectors.forEach(select => listen(select, 'change', selectVariant));
    radios.forEach(radio => listen(radio, 'change', () => { if (!cartBusy()) refreshPurchase({ announceChange: true }); }));
    // The same option is intentionally applied to every box in a selected offer.
    const track = $('[data-cc-gallery]');
    const media = () => track ? [...track.querySelectorAll('[data-cc-media]')] : [];
    const imageMedia = () => media().filter(item => item.hasAttribute('data-cc-image'));
    const dotsHost = $('[data-cc-gallery-dots]');
    let dots = [];
    function renderDots() {
      if (!dotsHost) return;
      dotsHost.replaceChildren();
      dots = media().map((item, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'gallery-dot';
        button.setAttribute('aria-label', `${track?.dataset.ccDotLabel || 'Show product media'} ${index + 1}`);
        listen(button, 'click', () => showGallery(index));
        dotsHost.append(button);
        return button;
      });
      const controls = $('[data-cc-gallery-controls]');
      if (controls) controls.hidden = media().length < 2;
      updateGallery();
    }
    function updateGallery() {
      if (!track) return;
      const width = media()[0]?.getBoundingClientRect().width || 1;
      galleryIndex = mobile() ? Math.max(0, Math.min(media().length - 1, Math.round(track.scrollLeft / width))) : 0;
      dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === galleryIndex)));
    }
    function showGallery(index) {
      const items = media();
      if (!track || !items.length) return;
      const next = (index + items.length) % items.length;
      track.scrollTo({ left: next * items[0].getBoundingClientRect().width, behavior: behavior() });
    }
    function showVariantMedia(id) {
      if (!track || !id) return;
      const selected = media().find(item => String(item.dataset.mediaId) === String(id));
      if (!selected) return;
      // Keep the selected Shopify media first in both the mobile carousel and desktop mosaic.
      track.prepend(selected);
      renderDots();
      track.scrollTo({ left: 0, behavior: 'instant' });
    }
    listen(track, 'scroll', updateGallery, { passive: true });
    listen(track, 'keydown', event => {
      if (!mobile() || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); showGallery(galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    listen($('[data-cc-gallery-prev]'), 'click', () => showGallery(galleryIndex - 1));
    listen($('[data-cc-gallery-next]'), 'click', () => showGallery(galleryIndex + 1));
    const zoom = $('[data-cc-image-dialog]');
    function showZoom(index) {
      const images = imageMedia();
      if (!zoom || !images.length) return;
      zoomIndex = (index + images.length) % images.length;
      const selected = images[zoomIndex];
      const image = $('[data-cc-zoom-image]');
      if (image) { image.src = selected.dataset.ccLarge; image.alt = selected.querySelector('img')?.alt || data.productTitle || ''; }
      setText('[data-cc-zoom-count]', `${zoomIndex + 1} / ${images.length}`);
    }
    imageMedia().forEach(button => listen(button, 'click', () => {
      showZoom(imageMedia().indexOf(button));
      if (zoom && !zoom.open) zoom.showModal();
    }));
    listen($('[data-cc-zoom-close]'), 'click', () => zoom?.close());
    listen($('[data-cc-zoom-prev]'), 'click', () => showZoom(zoomIndex - 1));
    listen($('[data-cc-zoom-next]'), 'click', () => showZoom(zoomIndex + 1));
    listen(zoom, 'keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); showZoom(zoomIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    listen(zoom, 'click', event => {
      if (event.target !== zoom) return;
      const bounds = zoom.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) zoom.close();
    });
    function updateSticky() {
      const main = form?.querySelector('[data-cc-add]');
      const sticky = $('[data-cc-sticky]');
      if (!sticky) return;
      if (!main) { sticky.hidden = true; return; }
      const header = document.querySelector('#header-component');
      const headerBottom = header?.getBoundingClientRect().bottom || 0;
      sticky.hidden = !mobile() || main.getBoundingClientRect().bottom >= Math.max(0, headerBottom);
    }
    listen(window, 'scroll', updateSticky, { passive: true });
    listen(window, 'resize', () => { updateGallery(); updateSticky(); });
    renderDots();
    refreshPurchase({ clearError: true });
    updateSticky();
    root.dataset.ccUiReady = 'true';
    root.ccRefreshProductUI = refreshPurchase;
    instances.set(root, { abort, zoom });
    root.dispatchEvent(new CustomEvent('cc:product-ready', { bubbles: true, detail: { product: data, variant } }));
  }
  function initAll(scope = document) {
    if (scope.matches?.('[data-cc-product]')) init(scope);
    scope.querySelectorAll?.('[data-cc-product]').forEach(init);
  }
  function destroy(scope) {
    for (const [root, instance] of instances) {
      if (root === scope || scope.contains?.(root)) {
        if (instance.zoom?.open) instance.zoom.close();
        instance.abort.abort(); instances.delete(root);
      }
    }
  }
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  document.addEventListener('DOMContentLoaded', () => initAll());
  window.CurvilaCactoxProductUI = { init: initAll, destroy };
  if (document.readyState !== 'loading') initAll();
})();
